/**
 * The invite-your-team pop-up's one showing: set when the workspace's creator
 * finishes onboarding, cleared once the pop-up closes. localStorage, holding
 * the user's id, so another account signed in on this browser never inherits
 * it.
 */

const KEY = 'cl_team_invite_prompt';

export function markTeamInvitePrompt(userId: string | undefined): void {
  if (!userId) return;
  try {
    localStorage.setItem(KEY, userId);
  } catch {
    // Storage off: no pop-up; invites stay in Settings > Team.
  }
}

export function teamInvitePromptPending(userId: string | undefined): boolean {
  if (!userId) return false;
  try {
    return localStorage.getItem(KEY) === userId;
  } catch {
    return false;
  }
}

export function clearTeamInvitePrompt(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Nothing to clear.
  }
}
